'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('oddSurveyModule')
    .factory('oddSurveyService', ['$http', '$q', function ($http) {
        var surveyBaseUrl = environment.apiUrl + '/Pilot/api/SurveyV2';

        var service = {};

        service.getLookups = function () {
            var reqUrl = surveyBaseUrl + '/Lookup';

            return $http
                    .get(reqUrl, {cache: true})
                    .then(function (response) { return response.data; })
        };

        return service;
    }]);
